var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          attrs: {
            model: _vm.childData,
            "label-position": "right",
            inline: "",
            "label-width": "130px"
          }
        },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.listNumber") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "280px" },
                    attrs: { disabled: "", type: "text" },
                    model: {
                      value: _vm.childData.flowNum,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "flowNum", $$v)
                      },
                      expression: "childData.flowNum"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.positionInfo") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "280px" },
                    attrs: {
                      disabled: "",
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 2 }
                    },
                    model: {
                      value: _vm.childData.houseCode,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "houseCode", $$v)
                      },
                      expression: "childData.houseCode"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.repairPerson") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "280px" },
                    attrs: { disabled: "", type: "text" },
                    model: {
                      value: _vm.childData.userName,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "userName", $$v)
                      },
                      expression: "childData.userName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.contactNumber") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "280px" },
                    attrs: { disabled: "", type: "text" },
                    model: {
                      value: _vm.childData.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "phone", $$v)
                      },
                      expression: "childData.phone"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.repairDetail") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "720px" },
                    attrs: {
                      disabled: "",
                      type: "textarea",
                      autosize: { minRows: 3, maxRows: 3 }
                    },
                    model: {
                      value: _vm.childData.content,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "content", $$v)
                      },
                      expression: "childData.content"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("h3", { staticStyle: { "padding-bottom": "10px" } }, [
        _vm._v("服务派工")
      ]),
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.dispatchData,
            rules: _vm.rules,
            "label-position": "right",
            inline: "",
            "label-width": "130px"
          }
        },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("table.appointTo"),
                    prop: "repairUserList"
                  }
                },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "280px" },
                    attrs: {
                      options: _vm.options,
                      props: _vm.propstree,
                      placeholder: "请选择派工人员"
                    },
                    model: {
                      value: _vm.dispatchData.repairUserList,
                      callback: function($$v) {
                        _vm.$set(_vm.dispatchData, "repairUserList", $$v)
                      },
                      expression: "dispatchData.repairUserList"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.sendExtandRemark") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "720px" },
                    attrs: {
                      type: "textarea",
                      maxlength: "255",
                      placeholder: "请输入备注",
                      autosize: { minRows: 3, maxRows: 3 }
                    },
                    model: {
                      value: _vm.dispatchData.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.dispatchData, "remark", $$v)
                      },
                      expression: "dispatchData.remark"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handDispatch } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }